// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3VmkT","approved":"Status_approved__1d3qZ","rejected":"Status_rejected__fEvtC","expired":"Status_expired__1tpmC","label":"Status_label__1GoLF"};